import React, { CSSProperties } from 'react';

import MContainerView from './MContainer.view';

type Props = {
  className?: string;
  style?: CSSProperties;
}

const MContainer: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MContainerView className={props.className} style={props.style}>
      {props.children}
    </MContainerView>
  );
};

MContainer.displayName = 'MContainer';
MContainer.defaultProps = {};

export default MContainer;
